<template>
  <div id="app">
    <o-prototype-navigation />
    <div class="c-device-wrapper">
      <o-device-preview>
        <transition :name="transitionName">
          <router-view />
        </transition>
      </o-device-preview>
    </div>
  </div>
</template>

<script>
import tinycolor from 'tinycolor2'
import ODevicePreview from '@/components/ODevicePreview.vue'
import OPrototypeNavigation from '@/components/OPrototypeNavigation.vue'

export default {
  name: 'App',
  components: {
    ODevicePreview,
    OPrototypeNavigation
  },
  data() {
    return {
      transitionName: 'slide-left'
    }
  },
  computed: {
    primaryColor() {
      return this.$store.state.primaryColor
    }
  },
  watch: {
    primaryColor: {
      immediate: true,
      handler(value, oldValue) {
        const baseColor = tinycolor(value)
        const lightColor = tinycolor(value).setAlpha(0.1)
        const overlayColor = tinycolor(value).setAlpha(0.9)
        document.documentElement.style.setProperty(
          '--primary-color',
          baseColor.toRgbString()
        )
        document.documentElement.style.setProperty(
          '--primary-color-light',
          lightColor.toRgbString()
        )
        document.documentElement.style.setProperty(
          '--primary-color-overlay',
          overlayColor.toRgbString()
        )
      }
    },
    $route(to, from) {
      if (from.name === 'home' && to.name === 'tickets') {
        this.transitionName = 'slide-up'
      } else if (to.name === 'home' && from.name === 'tickets') {
        this.transitionName = 'slide-down'
      } else if (to.name === 'kbc') {
        this.transitionName = 'slide-right'
      } else if (from.name === 'kbc') {
        this.transitionName = 'slide-left'
      } else {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/reset.scss';
@import './assets/styles/generic.scss';

:root {
  --primary-color: #{$primary-color};
  --primary-color-light: #{rgba($primary-color, 0.1)};
  --primary-color-overlay: #{rgba($primary-color, 0.98)};
  --text-color: #{$text-color};
  font-size: 62.5%;
}

html,
body {
  height: 100%;
}

body {
  box-sizing: border-box;
  color: $text-color;
  color: var(--text-color);
  display: flex;
  flex-direction: column;
  font: $font;

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
}

#app {
  display: flex;
  height: 100%;
}

.c-device-wrapper {
  background: $background-color;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.1s ease-in-out;
}

.slide-right-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter-to,
.slide-right-leave,
.slide-left-enter-to,
.slide-left-leave {
  transform: translateX(0);
}

.slide-right-leave-to,
.slide-left-enter {
  transform: translateX(100%);
}

.slide-up-enter-active {
  transition: all 0.2s ease-in-out;
}

.slide-down-leave-active {
  transition: all 0.2s ease-in-out;
}

.slide-up-enter {
  opacity: 0;
  transform: translateY(100%);
}

.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.slide-down-leave {
  opacity: 1;
  transform: translateY(0);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
